module.exports = __webpack_public_path__ + "static/media/Error404PageView.design@mobile.b749593d.png";